import { eventBus, EVENTS } from './EventBus.js';
import API from './Api.js';
const GET_REMOTE_INTERVAL = 15000;
let cceSongs = [];
let currentSong = {};
let nextSong = {};
let prevSong = {};


// eventBus.on(EVENTS.NEW_SONG, () => );
$(document).ready(function () {
  // player.on('metadata', (e) => {
  //   try {
  //       console.log(currentSong);
  //     if (e.type == 'song' && e.song.id != currentSong.id) {
  //
  //         getSong(e.song).then(song => {
  //             var songTime = new Date();
  //             song.song_onair_time = songTime.getHours() + ":" + songTime.getMinutes();
  //             if(currentSong.id){
  //               prevSong=currentSong;
  //               if(cceSongs.indexOf(prevSong.id) == -1){
  //                   eventBus.emit(EVENTS.CCE_NEW_SONG, prevSong);
  //                   cceSongs.unshift(prevSong);
  //               }
  //             }
  //             console.log(song);
  //             currentSong = song;
  //             eventBus.emit(EVENTS.CURRENT_SONG, currentSong);
  //         });
  //     }else if(e.type != 'song' && currentSong.id ){
  //         if(cceSongs.indexOf(currentSong.id) == -1){
  //           eventBus.emit(EVENTS.CCE_NEW_SONG, currentSong);
  //           currentSong = {};
  //         }
  //
  //         // eventBus.emit(EVENTS.NEXT_SONG, nextSong);
  //
  //         var resp = getSongStatus();
  //         console.log("qui", resp);
  //
  //     }
  //   } catch (error) {
  //     console.warn(error);
  //   }
  // });
});

function getRemoteCce() {
  return new Promise((resolve, reject) => {
    API.get("site/che_canzone_era", {}, (resp) => {
      if ((resp.status == 0)) {
        resolve(resp.songs);
      } else {
        reject()
      }
    });
  });
}

function getSong(song) {
  return new Promise((resolve, reject) => {
    API.get("site/get_song", { idsong: song.idMasterControl }, function (resp) {
      if ((resp.status == 1)) {
        resolve(resp.data);
      } else {
        reject()
      }
    });
  });
}

function getSongStatus() {
  return new Promise((resolve, reject) => {

      API.get("site/status_song", {  }, function (resp) {
          resolve(resp);
      });

    // $.get('https://media.rds.it/json/rds/current', {}, (resp) => {
    //
    // });
  });
}

function getLyricsById(songId){
  return new Promise((resolve, reject) => {
    API.get("site/getLyricsById", {sid:songId},  (resp) => {
      resolve(resp);
    });
  });
}

function getPlayerInfo(){
    return new Promise((resolve, reject) => {
        API.get("site/get_player_info", {},  (resp) => {
            resolve(resp);
        });
    });
}


function getPlayerInfoSerieA(){
  return new Promise((resolve, reject) => {
    API.get("site/get_player_info_seriea", {},  (resp) => {
      resolve(resp);
    });
  });
}


function getAllRemote() {
    Promise.all([getPlayerInfo(),getPlayerInfoSerieA()]).then(values => {
      console.log('values',values);
      parseRDS(values[0]);
      parseSerieA(values[1]);
        // }
    });
}


function parseRDS(values) {
  const songStatus = values.song_status;
  const remoteCce = values.songs;
  const current_lyrics = values.current_lyrics;
  // if (!window.player || !player.playing()) {

  const mapSong = (s) => {

    let song = {
      id: s.id,
      artist: s.artist,
      cover: s.cover,
      master_control: s.id_master_control,
      title: s.title,
      likes: s.likes
    };
    return song;
  }
  if (songStatus.current_song.type == 'song') {
    const song = mapSong(songStatus.current_song);
    if ((!currentSong.id && !prevSong.id) || (currentSong.id != song.id && song.id != prevSong.id)) {
      prevSong = currentSong;
      eventBus.emit(EVENTS.CURRENT_SONG, song);

      $(".che_canzone_era_header_title").html(current_lyrics.title);
      $(".che_canzone_era_header_artist").html(current_lyrics.artist);
      if (current_lyrics.found) {
        var lyrics = current_lyrics.lyrics;
        lyrics = lyrics.replace('<br><br>', '<br>');
        $(".che_canzone_era_header_lyrics").html(lyrics);
        $('#icona_lyrics').removeClass('disabled');
        $('#player_lyrics').removeClass('disabled');
        $('#icona_lyrics_mobile').removeClass('disabled');
      } else {
        $('#icona_lyrics').addClass('disabled');
        $('#player_lyrics').addClass('disabled');
        $('#icona_lyrics_mobile').addClass('disabled');
      }

      currentSong = song;
    }
  } else {
    $(".che_canzone_era_header_lyrics").html("Testo non presente per questo brano");
    $('#icona_lyrics').addClass('disabled');
    $('#player_lyrics').addClass('disabled');
    $('#icona_lyrics_mobile').addClass('disabled');
    const song = mapSong(songStatus.next_song);
    if ((!prevSong.id && !nextSong.id) || (nextSong.id != song.id && song.id != prevSong.id)) {
      prevSong = currentSong;
      eventBus.emit(EVENTS.NEXT_SONG, song);
      nextSong = song;
    }
  }

  //remotecce
  if (window.cceSongs) {
    cceSongs = window.cceSongs;
    delete window.cceSongs;
  }
  if (JSON.stringify(remoteCce) == JSON.stringify(cceSongs)) {
    return;
  }
  const songIds = cceSongs.map(s => s.sid);
  const newSongs = remoteCce.filter(s => songIds.indexOf(s.sid) === -1);
  cceSongs = remoteCce;
  const newSongsRevert = newSongs.reverse();
  for (const newSong of newSongsRevert) {
    eventBus.emit(EVENTS.CCE_NEW_SONG, newSong);
  }
}


function parseSerieA(values){
    document.getElementById('title_seriea').innerText = values.song_status.current_song.title;
    document.getElementById('subtitle_seriea').innerText = values.song_status.current_song.artist;
}



// function getAllRemote() {
//   Promise.all([getSongStatus(), getRemoteCce()]).then(values => {
//     const songStatus = values[0];
//     const remoteCce = values[1];
//     if (!window.player || !player.playing()) {
//
//       const mapSong = (s) => {
//
//         let song = {
//           id: s.id,
//           artist: s.artist,
//           cover: s.cover,
//           master_control: s.id_master_control,
//           title: s.title
//         };
//         return song;
//       }
//       if (songStatus.current_song.type == 'song') {
//         const song = mapSong(songStatus.current_song);
//         if ((!currentSong.id && !prevSong.id) || (currentSong.id != song.id && song.id != prevSong.id)) {
//           prevSong = currentSong;
//           eventBus.emit(EVENTS.CURRENT_SONG, song);
//           getLyricsById(song.id).then((resp)=>{
//             $(".che_canzone_era_header_title").html(resp.title);
//             $(".che_canzone_era_header_artist").html(resp.artist);
//             if (resp.found) {
//                 var lyrics = resp.lyrics;
//                 lyrics = lyrics.replace('<br><br>', '<br>');
//                 $(".che_canzone_era_header_lyrics").html(lyrics);
//                 $('#icona_lyrics').removeClass('disabled');
//                 $('#player_lyrics').removeClass('disabled');
//                 $('#icona_lyrics_mobile').removeClass('disabled');
//             } else {
//               $('#icona_lyrics').addClass('disabled');
//               $('#player_lyrics').addClass('disabled');
//               $('#icona_lyrics_mobile').addClass('disabled');
//                 // $(".che_canzone_era_header_lyrics").html("Testo non presente per questo brano");
//             }
//           });
//           currentSong = song;
//         }
//       } else {
//         $(".che_canzone_era_header_lyrics").html("Testo non presente per questo brano");
//         $('#icona_lyrics').addClass('disabled');
//         $('#player_lyrics').addClass('disabled');
//         $('#icona_lyrics_mobile').addClass('disabled');
//         const song = mapSong(songStatus.next_song);
//         if ((!prevSong.id && !nextSong.id) || (nextSong.id != song.id && song.id != prevSong.id)) {
//           prevSong = currentSong;
//           eventBus.emit(EVENTS.NEXT_SONG, song);
//           nextSong = song;
//         }
//       }
//     }
//     //remotecce
//     if (window.cceSongs) {
//       cceSongs = window.cceSongs;
//       delete window.cceSongs;
//     }
//     if (JSON.stringify(remoteCce) == JSON.stringify(cceSongs)) {
//       return;
//     }
//     const songIds = cceSongs.map(s => s.sid);
//     const newSongs = remoteCce.filter(s => songIds.indexOf(s.sid) === -1);
//     cceSongs = remoteCce;
//     for (const newSong of newSongs) {
//       eventBus.emit(EVENTS.CCE_NEW_SONG, newSong);
//     }
//   });
// }


async function init() {

  $( document ).ready(function() {

    getAllRemote();
    setInterval(() => {
      getAllRemote();
    }, GET_REMOTE_INTERVAL);

  });


}


init();
